import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AuthenticationService from "../../Api/AuthenticationService";
import { AuthContext } from "../../Context/AuthContext";

const OtpVerification = () => {
  const AuthObject = new AuthenticationService();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [timer, setTimer] = useState(60);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const token = location.state?.token;
  const mobile_number = location.state?.mobile_number;
  const email = location.state?.email;
  const isSignIn = Boolean(mobile_number); // Check if it's a signin flow
  const { login } = useContext(AuthContext);

  useEffect(() => {
    if (!token && !email) {
      navigate(isSignIn ? '/' : '/sign-up');
      return;
    }

    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [token, email, navigate, isSignIn]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!otp || otp.length !== 6) {
      setError("Please enter a valid 6-digit OTP");
      return;
    }

    setIsLoading(true);
    try {
      const authData = {
        token,
        email,
        otp_code: otp
      };

      const success = await login(authData);

      if (success) {
        navigate('/course-list');
      } else {
        setError("Invalid OTP. Please try again.");
      }
    } catch (error) {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (timer > 0) return;

    setIsLoading(true);
    try {
      const response = await AuthObject.ResendOtp({
        token,
        email,
        mobile_number
      });
      const data = await response.data;

      if (response.status === 200 && data.status === "success") {
        setTimer(60);
      } else {
        setError(data.message || "Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div>
        <Link to="/" className="mb-40 max-w-290-px">
          <img src="assets/images/logo.png" alt="" />
        </Link>
        <h4 className="mb-12">OTP Verification</h4>
        <p className="mb-32 text-secondary-light text-lg">
          Please enter the verification code sent to your {isSignIn ? 'mobile number' : 'email'}
          {mobile_number && <strong> {mobile_number}</strong>}
          {email && <strong> {email}</strong>}
        </p>
      </div>
      {error && (
        <div className="alert alert-danger mb-3" role="alert">
          {error}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="icon-field mb-16">
          <span className="icon top-50 translate-middle-y">
            <Icon icon="solar:lock-password-outline" />
          </span>
          <input
            type="text"
            className={`form-control h-56-px bg-neutral-50 radius-12 ${error ? 'is-invalid' : ''}`}
            placeholder="Enter 6-digit OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
            maxLength={6}
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
          disabled={isLoading}
        >
          {isLoading ? (
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          ) : null}
          Verify OTP
        </button>

        <div className="mt-32 text-center">
          <p className="text-sm mb-2">
            Didn't receive the code?{" "}
            <button
              type="button"
              onClick={handleResendOtp}
              className={`text-primary-600 fw-semibold border-0 bg-transparent ${(timer > 0 || isLoading) ? 'opacity-50 cursor-not-allowed' : ''}`}
              disabled={timer > 0 || isLoading}
            >
              Resend OTP {timer > 0 ? `(${timer}s)` : ''}
            </button>
          </p>
        </div>
      </form>
    </>
  );
};

export default OtpVerification; 